export enum ACTION_GROUP_CODES {
	APPLICATION = 'APP',
	APPEAL = 'ALA',
	RULES = 'RUL',
	CLIENT = 'CLI',
	PARTICIPANT = 'PAR',
	APPLICATION_EDIT = 'APE',
	DOCUMENT_MANAGEMENT = 'DCM',
	APPLICATION_OTHER = 'APO',
	LOAN = 'LOA',
	PAYMENT_SOLUTIONS_DASHBOARD = 'PAY',
	TASK_VIEW_PAGE = 'TKM',
	WORKFLOW_VIEW_PAGE = 'WFM',
	EDUCATIONAL_PROVIDER = 'EDP'
}
